import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaPinterest } from 'react-icons/fa';
import { useAuthStore } from '../store/authStore';
import { useAuthModalStore } from '../store/authModalStore';
import { VersionBadge } from './VersionBadge';
import logo from '../assets/logo.png';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const openRegister = useAuthModalStore((s) => s.openRegister);

  return (
    <footer className="footer">
      <div className="footer__main">
        <div className="footer__grid">
          {/* Brand */}
          <div className="footer__col footer__col--brand">
            <div className="footer__brand-row">
              <img src={logo} alt="VIN Pulse OS" className="footer__brand-logo" />
              <span className="footer__brand-text">
                VIN <span className="footer__brand-accent">Pulse</span> OS
              </span>
            </div>
            <p className="footer__about-text">
              A wholesale distribution and retail platform powered by VIN Pulse
              OS — built for efficiency, reliability, and scale across retail
              supply chains.
            </p>
            <div className="footer__social">
              <a href="#" className="footer__social-link" aria-label="Facebook"><FaFacebook /></a>
              <a href="#" className="footer__social-link" aria-label="Twitter"><FaTwitter /></a>
              <a href="#" className="footer__social-link" aria-label="Instagram"><FaInstagram /></a>
              <a href="#" className="footer__social-link" aria-label="Pinterest"><FaPinterest /></a>
            </div>
          </div>

          {/* Platform */}
          <div className="footer__col">
            <h4 className="footer__col-title">Platform</h4>
            <ul className="footer__links">
              <li><Link to="/products" className="footer__link">Product Catalog</Link></li>
              <li><Link to="/orders" className="footer__link">Order Tracking</Link></li>
              {!isAuthenticated && (
                <li><Link to="/partner" className="footer__link">Partner Portal</Link></li>
              )}
              <li><Link to="/about" className="footer__link">VIN Pulse OS</Link></li>
              <li><Link to="/about" className="footer__link">Delivery Network</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div className="footer__col">
            <h4 className="footer__col-title">Company</h4>
            <ul className="footer__links">
              <li><Link to="/about" className="footer__link">About VIN</Link></li>
              <li><Link to="/about" className="footer__link">Coverage Area</Link></li>
              <li><Link to="/careers" className="footer__link">Careers</Link></li>
              <li><Link to="/about" className="footer__link">Press & Media</Link></li>
              <li><Link to="/about" className="footer__link">Partner Stories</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div className="footer__col">
            <h4 className="footer__col-title">Support</h4>
            <ul className="footer__links">
              <li><Link to="/contact" className="footer__link">Partner Support</Link></li>
              <li><Link to="/contact" className="footer__link">Help Centre</Link></li>
              {!isAuthenticated && (
                <li><button type="button" className="footer__link" onClick={openRegister}>Become a Partner</button></li>
              )}
              <li><Link to="/privacy" className="footer__link">Privacy Policy</Link></li>
              <li><Link to="/terms" className="footer__link">Terms of Service</Link></li>
              <li><a href="tel:5028074201" className="footer__link">📞 5028074201</a></li>
              <li><a href="mailto:info@vindistro.com" className="footer__link">✉️ info@vindistro.com</a></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer__bottom">
        <p className="footer__copyright">
          &copy; {new Date().getFullYear()} VIN Services. All rights reserved.
        </p>
        <VersionBadge />
      </div>
    </footer>
  );
};

export default Footer;
